module.exports = __webpack_public_path__ + "img/页面_1.3.e4397759.png";